<template>
    <div class="bg-fondoblanco pb-32 min-h-screen">
        <div class="bg-gray-200 pt-8 pill-background h-64 bg-cover bg-center bg-no-repeat" :style="pill && pill.backgroundImage ? `background: url('${bgImage}')`: ''">
            <div class="flex justify-left mb-6 px-4">
                <router-link to="/" class>
                    <button
                        class="bg-white bg-opacity-50 text-gray-0 mt-3 px-5 pt-1 pb-3 rounded-lg hover:bg-azuloscuro hover:text-white mr-4 mb-2"
                    >
                        <Zondicon icon="arrow-thin-left" class="fill-current inline-block h-4 line mt-1" />
                    </button>
                </router-link>
            </div>
        </div>

        <div class="grid grid-cols-2 gap-6 py-4">
            <div class="px-4 text-left">
                <label v-if="assignedPill.done" class="bg-verdeclaro rounded-sm text-white text-xs px-2 py-1">
                <Zondicon icon="checkmark" class="fill-current inline-block h-3 line -mt-1 mr-2" />¡Pill realizada!
            </label>
                <label v-else class="bg-azuloscuro rounded-sm text-white text-xs px-2 py-1">
                    ¡Estás a tiempo!
                </label>
            </div>
            <div class="px-4 pt-1 text-right">
                <img v-if="!wishlist" v-on:click="modifyWishlist" src="@/assets/images/heart.svg"
                     class="float-right h-6"/>
                <img v-if="wishlist" v-on:click="modifyWishlist" src="@/assets/images/Favoritos.svg"
                     class="h-6 float-right"/>
            </div>
        </div>


        <h3 class="text-azuloscuro text-xl font-semibold p-4 mb-4 leading-6">
            {{ pill.contentTitle }}
        </h3>

        <div class="mb-4 px-4">
            <p class="text-black">{{pill.content}}</p>
        </div>

        <div v-if="!assignedPill.done">
            <div v-if="pill.evaluated">
                <h3 class="text-azuloscuro text-xl font-semibold p-4 mb-4 leading-6">
                    {{ pill.questionTitle }}
                </h3>

                <div v-if="pill.question1 && questionQuantity >= 1" class="mb-6 px-4">
                    <div class="flex justify-start">
                        <strong class="ml-2 mr-2">1.</strong>
                        <p class="text-black">{{pill.question1}}</p>
                    </div>
                    <div class="flex justify-around mx-12 mt-6">
                        <button @click="() => setTestAnswer('a1', true)"
                                class=" px-4 pt-2 pb-4 rounded-lg border border-gray-300"
                                :class="(passed.a1 !== null && passed.a1 === true) ?  unselectedCheckClass : activeClass">
                            <Zondicon icon="checkmark" class="fill-current inline-block h-5 mt-2 line"/>
                        </button>

                        <button @click="() => setTestAnswer('a1', false)"
                                class="px-4 pt-2 pb-4 rounded-lg border border-gray-300"
                                :class="(passed.a1 !== null && passed.a1 === false) ?  unselectedCrossClass : activeClass">
                            <Zondicon icon="close" class="fill-current inline-block h-5 mt-2 line"/>
                        </button>
                    </div>
                </div>


                <div v-if="pill.question2 && questionQuantity >= 2" class="mb-6 px-4">
                    <div class="flex justify-start">
                        <strong class="ml-2 mr-2">2.</strong>
                        <p class="text-black">{{pill.question2}}</p>
                    </div>
                    <div class="flex justify-around mx-12 mt-6">
                        <button @click="() => setTestAnswer('a2', true)"
                                class="px-4 pt-2 pb-4 rounded-lg border border-gray-300"
                                :class="(passed.a2 !== null && passed.a2 === true) ?  unselectedCheckClass : activeClass">
                            <Zondicon icon="checkmark" class="fill-current inline-block h-5 mt-2 line"/>
                        </button>

                        <button @click="() => setTestAnswer('a2', false)"
                                class="px-4 pt-2 pb-4 rounded-lg border border-gray-300"
                                :class="(passed.a2 !== null && passed.a2 === false) ?  unselectedCrossClass : activeClass">
                            <Zondicon icon="close" class="fill-current inline-block h-5 mt-2 line"/>
                        </button>
                    </div>
                </div>

                <div v-if="pill.question3 && questionQuantity >= 3" class="mb-6 px-4">
                    <div class="flex justify-start">
                        <strong class="ml-2 mr-2">3.</strong>
                        <p class="text-black">{{pill.question3}}</p>
                    </div>
                    <div class="flex justify-around mx-12 mt-6">
                        <button @click="() => setTestAnswer('a3', true)"
                                class="px-4 pt-2 pb-4 rounded-lg border border-gray-300"
                                :class="(passed.a3 !== null && passed.a3 === true) ?  unselectedCheckClass : activeClass">
                            <Zondicon icon="checkmark" class="fill-current inline-block h-5 mt-2 line"/>
                        </button>

                        <button @click="() => setTestAnswer('a3', false)"
                                class="px-4 pt-2 pb-4 rounded-lg border border-gray-300"
                                :class="(passed.a3 !== null && passed.a3 === false) ?  unselectedCrossClass : activeClass">
                            <Zondicon icon="close" class="fill-current inline-block h-5 mt-2 line"/>
                        </button>
                    </div>
                </div>
                <div v-if="pill.question4 && questionQuantity >= 4" class="mb-6 px-4">
                    <div class="flex justify-start">
                        <strong class="ml-2 mr-2">4.</strong>
                        <p class="text-black">{{pill.question4}}</p>
                    </div>
                    <div class="flex justify-around mx-12 mt-6">
                        <button @click="() => setTestAnswer('a4', true)"
                                class="px-4 pt-2 pb-4 rounded-lg border border-gray-300"
                                :class="(passed.a4 !== null && passed.a4 === true) ?  unselectedCheckClass : activeClass">
                            <Zondicon icon="checkmark" class="fill-current inline-block h-5 mt-2 line"/>
                        </button>

                        <button @click="() => setTestAnswer('a4', false)"
                                class="px-4 pt-2 pb-4 rounded-lg border border-gray-300"
                                :class="(passed.a4 !== null && passed.a4 === false) ?  unselectedCrossClass : activeClass">
                            <Zondicon icon="close" class="fill-current inline-block h-5 mt-2 line"/>
                        </button>
                    </div>
                </div>
                <div v-if="pill.question5 && questionQuantity >= 5" class="mb-6 px-4">
                    <div class="flex justify-start">
                        <strong class="ml-2 mr-2">5.</strong>
                        <p class="text-black">{{pill.question5}}</p>
                    </div>
                    <div class="flex justify-around mx-12 mt-6">
                        <button @click="() => setTestAnswer('a5', true)"
                                class="px-4 pt-2 pb-4 rounded-lg border border-gray-300"
                                :class="(passed.a5 !== null && passed.a5 === true) ?  unselectedCheckClass : activeClass">
                            <Zondicon icon="checkmark" class="fill-current inline-block h-5 mt-2 line"/>
                        </button>

                        <button @click="() => setTestAnswer('a5', false)"
                                class="px-4 pt-2 pb-4 rounded-lg border border-gray-300"
                                :class="(passed.a5 !== null && passed.a5 === false) ?  unselectedCrossClass : activeClass">
                            <Zondicon icon="close" class="fill-current inline-block h-5 mt-2 line"/>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!assignedPill.done">
            <div class="mb-4 px-4">
                <div class="mt-20">
                    <button class="bg-azuloscuro hover:bg-greenlight text-white py-2 px-4 rounded-full focus:outline-none w-full"
                            @click="finish()"
                            type="button">
                        Terminar
                    </button>
                </div>

                <div class="mt-5 text-center">
                    <router-link
                            to="/"
                            class="inline-block self-center text-sm text-blue-500 hover:text-blue-800">
                        Terminar más tarde
                    </router-link>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="mb-4 px-4">
                <div class="mt-20 text-center">
                    <router-link
                            to="/"
                            tag="button"
                            class="bg-azuloscuro hover:bg-greenlight text-white py-2 px-4 rounded-full focus:outline-none w-full">
                        Atrás
                    </router-link>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue'
    import Utilities from '@/plugins/Utilities.js'
    import Zondicon from 'vue-zondicons'
    import Menu from '@/components/Menu'
    import users from '@/plugins/api/users/users'
    import pills from "../plugins/api/pills/pills";
    import auth from "@/plugins/api/users/auth";
    import wishlist from "../plugins/api/wishlist/wishlist"
    import setTitle from "../plugins/title";

    const PillsText = {
        name: 'PillsText',
        layout: 'layout',
        components: {
            Menu,
            Zondicon
        },
        data: function(){
            return {
                assignedPill: null,
                pill: null,
                passed: { a1:null, a2:null, a3:null, a4:null, a5:null },
                questionQuantity: 0,
                activeClass: ['bg-white', 'text-azuloscuro'],
                unselectedCrossClass: ['text-red', 'bg-azuloscuro'],
                unselectedCheckClass: ['text-greencorrect', 'bg-azuloscuro'],
                wishlist: false,
            }
        },
        beforeMount: function(){
            if(!Utilities.isLogged()){
                this.$router.push({ name:'login' })
            }
            if (!this.$route.params.i) {
                const local = JSON.parse(localStorage.getItem('last_pill') || {});
                if (!local || !local.i) {
                    this.$router.push({ name: 'home' })
                    return
                }
                this.assignedPill = local.i
                this.idx = local.idx
            } else {
                this.assignedPill = this.$route.params.i;
            }
            this.assignedPill.tries += 1;
            this.loadPill();


            if (this.$route.params.test) {
                this.passed = this.$route.params.test
            }
        },
        computed: {
            getImageUrl() {
                return '';
            },
            bgImage() {
                if (!this.pill) {
                    return null
                }
                return auth.api.endpointPath.replace("api/v1/", "") + `media/${this.pill.backgroundImage}`
            },
            testComplete() {
                console.log(this.passed)
                const entries = Object.entries(this.passed).slice(0, this.questionQuantity);
                console.log(entries)
                return entries.every(([key, value]) => value !== null)
            },
            testCorrect() {
                const entries = Object.entries(this.passed).slice(0, this.questionQuantity);
                return entries.every(([key, value]) => value === this.pill[key.replace('a', 'answer')])
            }
        },
        created () {
            setTitle('Pill de Texto')
        },
        methods: {
            async modifyWishlist(){
                if(this.wishlist){
                    await wishlist
                        .deleteWishList(this.wishlist)
                        .then(response => {
                            this.wishlist = false;
                        });
                }
                else{
                    await wishlist
                        .createWishList(
                            this.pill
                        )
                        .then(response => {
                            this.wishlist = response.data;
                        });
                }
            },
            finish() {
                if(!this.assignedPill.done){
                    this.updateTries();
                }
                if (!this.testComplete) {
                    this.$router.push({name: 'pills_incomplete', params: {i: this.assignedPill, idx: this.idx, test: this.passed}})
                    return
                }

                if (!this.testCorrect) {
                    this.$router.push({name: 'pills_error', params: {i: this.assignedPill, idx: this.idx, test: this.passed}})
                    return
                }

                this.assignedPill.done = true;
                this.markAsCompleted();
                let i = this.assignedPill
                this.$router.push({name: 'pills_completado', params: {i}})
            },
            async loadPill() {
                await pills
                    .getPillById(this.assignedPill.pill.id)
                    .then(response => {
                        this.pill = response
                        this.questionQuantity = this.pill.questionQuantity;
                    })
                    .catch(e => {
                        console.log(e);
                    });
                await wishlist.getWishList(this.pill).then(
                    response => {
                        var wishlist = response.data["hydra:member"]
                        this.wishlist =  wishlist.length > 0 ? wishlist[0] : false;
                    }
                )
            },
            markAsCompleted () {
                users.putAssignedPill(this.assignedPill)
            },
            updateTries () {
                users.putAssignedPill(this.assignedPill)
            },
            setTestAnswer(key, value) {
                this.$set(this.passed, key, value)
            }
        }
    }

    export default PillsText;
</script>

<style>
    .pill-background{
        background-image: url(../assets/images/background-pill.jpg);
        background-size: contain;
        background-position: center center;
    }
    .compactSound__artwork{
        display:none !important;
    }
</style>
